/** @format */

export const ROUTES = {
  OOPS: 'oops',
  ERRORS: 'errors',
  REDIRECT: 'redirect',

  DEFAULT_PROJECT: 'home/project',

  INDEX: '/',
  AUTH: 'auth',
  ADMIN: 'admin',
  GUEST: 'guest',
  WIZARD: 'wizard',
  HOME: 'home',
  SHARE: 'share',
  ADMIN_STATS: 'stats',

  EMAIL_SING_IN: 'sign-in-email',
  EMAIL_SING_UP: 'sign-up-email',
  PHONE_SIGN_UP: 'sign-up-phone',
  SIGN_IN: 'sign-in',
  SIGN_UP: 'sign-up',

  RESET_PASSWORD_SENT: 'reset-password/sent',
  RESET_PASSWORD: 'reset-password',
  PHONE_RESET_PASSWORD: 'reset-password-phone',
  EMAIL_RESET_PASSWORD: 'reset-password-email',

  VERIFY_CODE: 'verify-code',

  DEV_TRANSLATIONS: 'translations',
  DEV_MANAGERS: 'managers',
  DEV_INPUTS: 'inputs',
  DEV_BUTTONS: 'buttons',
  DEV_DASHBOARD: 'dashboard',
  DEV_SELECTS: 'selects',
  DEV_MENUS: 'menus',

  ASSESS_DENIED: 'access-denied',

  GUEST_CONNECT: 'connect',
  GUEST_FINISH: 'finish',
  GUEST_HELP: 'help',
  GUEST_BEFORE_CONNECT: 'connect/before-connect',
  GUEST_CONFIRM_DISCONNECT: 'connect/confirm-disconnect',
  GUEST_SUBACCOUNTS: 'connect/subaccounts',

  PROJECT: 'project',
  PROJECT_REPORTS: 'project/reports',
  MAIN: 'main',
  MAIN_WAIT: 'wait',
  MAIN_STATUS: 'status',
  MAIN_PROJECT: 'project',
  MAIN_CATEGORY: 'category',
  MAIN_DETAILS: 'details',
  MAIN_CONGRATULATION: 'congratulation',
  MAIN_GRAPHS: 'graphs',
  MAIN_WAIT_FOR_PAYMENT: 'wait-for-payment',
  MAIN_ERROR_SETTINGS: 'error-settings',
  MAIN_SCORE_DESCRIPTION: 'score-description',
  MAIN_BUDGET_SCORE_DESCRIPTION: 'budget-score-description',
  MAIN_REPORT: 'report',
  MAIN_REPORTS: 'reports',
  MAIN_ERROR_DESCRIPTION: 'error-description',
  MAIN_REGIONS: 'regions',
  MAIN_BAD_WORDS: 'bad-words',
  MAIN_CORRECT_WORDS: 'correct-words',
  MAIN_GEO_GROUPS: 'geo-groups',
  MAIN_STOP_WORDS: 'stop-words',

  DIGITAL_CAST: 'digital-cast',

  HOME_SETTINGS: 'home/settings',

  SETTINGS: 'settings',
  SETTINGS_PROFILE: 'profile',
  SETTINGS_TWO_FACTOR_AUTH: 'two-factor-auth',
  SETTINGS_CONNECTED_USERS: 'connected_users',
  SETTINGS_CONNECT: 'connect',
  SETTINGS_CONNECT_COMPANY: 'connect/company',
  SETTINGS_MANAGER: 'manager',
  SETTINGS_SPECIALISTS: 'specialists',
  SETTINGS_NOTIFICATIONS: 'notifications',
  SETTINGS_NOTIFICATION: 'notification',
  SETTINGS_SUBSCRIPTION: 'subscription',
  SETTINGS_PAYMENT_METHODS: 'payment-methods',
  SETTINGS_EXCEPTIONS: 'exceptions',
  SETTINGS_SPECIALIST: 'specialist',
  SETTINGS_CONNECTED_USERS_NEW: 'connected_users/new',
  SETTINGS_CONNECTED_USERS_ID: 'connected_users/:id',
  SETTINGS_GROUPING: 'grouping',
  SETTINGS_TARIFFS: 'tariffs',

  PROJECT_NEW: 'new',
  PROJECT_TYPE: 'type',
  PROJECT_FEEDS: 'feeds',
  PROJECT_FUNNEL: 'funnel',
  PROJECT_PERIODS: 'periods',
  PROJECT_WIZARD_NEW: 'wizard/new',
  PROJECT_CREATED: 'created',
  PROJECT_WIZARD_CREATED: 'wizard/created',
  PROJECT_WIZARD_CONSULT: 'wizard/consult',
  PROJECT_CREATED_WIZARD_SUBACCOUNTS: 'wizard/created/subaccounts',
  PROJECT_EDIT: 'edit',
  PROJECT_CREATED_SUBACCOUNTS: 'created/subaccounts',
  PROJECT_EDIT_SUBACCOUNTS: 'edit/subaccounts',
  PROJECT_CONFIRM_DELETE_COMPANY: 'confirm-delete-company',
  PROJECT_KPI: 'kpi',
  PROJECT_SENSORS: 'sensors',
  PROJECT_PERIOD: 'period',

  WIZARD_COMPANY: 'wizard/company',
  WIZARD_CONNECT: 'wizard/connect',
  WIZARD_BEFORE_CONNECT: 'connect/before-connect',
  WIZARD_CONFIRM_DISCONNECT: 'connect/confirm-disconnect',
  WIZARD_SUBACCOUNTS: 'connect/subaccounts',
  WIZARD_COMPANY_CONNECT: 'wizard/company/connect',
  WIZARD_COMPANY_BEFORE_CONNECT: 'wizard/company/connect/before-connect',
  WIZARD_COMPANY_CONFIRM_DISCONNECT: 'wizard/company/connect/confirm-disconnect',
  WIZARD_COMPANY_SUBACCOUNTS: 'wizard/company/connect/subaccounts',

  CONFIRM_DISCONNECT: 'connect/company/confirm-disconnect',
  BEFORE_CONNECT: 'connect/company/before-connect',
  CONNECT_SUBACCOUNTS: 'connect/company/subaccounts',
  CONFIRM_DELETE_COMPANY: 'connect/company/confirm-delete-company',
  CONNECT_BEFORE_CONNECT: 'connect/before-connect',
  CONNECT_CONFIRM_DISCONNECT: 'connect/confirm-disconnect',

  CONFIRM_PAY_ACCOUNTS: 'confirm-pay-accounts',
  CONFIRM_PREPAY_BUDGET: 'confirm-prepay-budget',
  CONFIRM_POSTPAY_BUDGET: 'confirm-postpay-budget',

  SHARE_UUID: ':uuid',

  CONNECT: 'connect',

  INVITE_GUEST: 'invite_guest',

  HELP: 'help',
  HELP_MATERIALS: 'help/materials',

  SUBACCOUNTS: 'subaccounts',

  WELCOME_GUEST_UUID: 'welcome/:guestUuid',

  CHIEF_REPORT: 'chief-report',
  CHIEF_REPORT_SUMMARY: 'summary',
  CHIEF_REPORT_STAFF: 'staff',

  GROUPING: 'grouping',
  OVERVIEW: 'overview',
  REPORTS: 'reports',
  REPORTS_NEW: 'reports/new',
  REPORT: 'report',
  SHARED_REPORT_BASE: 'shared-report',
  SHARED_REPORT: 'shared-report/:slug',

  YA_DIRECT_CHANGE_LOG: 'ya-direct-change-log',
  CAMPAIGN_STATISTICS: 'campaign-statistics',
  AI_REPORTS: 'ai-reports',
  AI_REPORTS_SHOW: '/:companyId/:orderId',

  CHATS: ':companyId/chats',
  CHATS_SHOW: ':chatId',
  COMPANY_REPORTS: 'projects/:companyId/reports',

  TARIFFS: 'tariffs',
};
